import {useMemo} from 'react';

import {useHydrateRecentlyViewed, useRecentlyViewedStore} from '../store/useRecentlyViewedStore';

/**
 * 최근 본 상품 목록. 최근 순이며, 상품을 볼 때 저장한 스냅샷이다.
 * @param {{limit?: number}} options
 */
export function useRecentlyViewedProducts({ limit } = {}) {
    const hydrated = useHydrateRecentlyViewed();
    const entries = useRecentlyViewedStore((state) => state.entries);

    const items = useMemo(
        () => entries.slice(0, limit ?? entries.length).map((entry) => entry.product),
        [entries, limit]
    );

    return {
        items,
        hydrated,
        hasHistory: entries.length > 0,
    };
}
